<template>
    <c-dialog ref="dialog" title="派单日志" mode="slide" width="1000" enable-flex mask-close :button="false" @close="$refs.filterWindow.hide(); $refs.scoreWindow.hide();">
        <div class="m-detail-box">
            <c-title>派单结果</c-title>
            <c-detail column="2">
                <c-detail-item label="工单编号">
                    {{dispatch_result.work_order_code}}
                    <c-state v-if="dispatch_result.urgency_level != 1" dict="urgencyLevelDic" tag :value="dispatch_result.urgency_level"></c-state>
                </c-detail-item>
                <c-detail-item label="客户位置">
                    {{dispatch_result.execute_location}}
                </c-detail-item>
                <c-detail-item label="预约开始时间">
                    {{dispatch_result.appointment_start_time}}
                </c-detail-item>
                <c-detail-item label="预约结束时间">
                    {{dispatch_result.appointment_end_time}}
                </c-detail-item>
                <c-detail-item label="必备技能">
                    {{dispatch_result.required_skills||'--'}}
                </c-detail-item>
                <c-detail-item label="派单时间">
                    {{dispatch_result.dispatch_time}}
                </c-detail-item>
                <c-detail-item label="派单结果">
                    {{dispatch_result.dispatch_remark}}
                </c-detail-item>
            </c-detail>

            <c-title v-if="manual_dispatch_logs && manual_dispatch_logs.length>0">手动派单记录</c-title>
            <c-table v-if="manual_dispatch_logs && manual_dispatch_logs.length>0" ref="manualDispatchLogs" :data="manual_dispatch_logs" border :paging="false">
                <c-table-column
                        label="派单时间"
                        width="100"
                        name="dispatch_time"
                >
                    <template #default="{data}">
                        {{data.dispatch_time}}
                    </template>
                </c-table-column>
                <c-table-column
                        label="工程师"
                        width="100"
                        name="assigned_engineer_name"
                >
                    <template #default="{data}">
                        {{data.assigned_engineer_name}}
                    </template>
                </c-table-column>
                <c-table-column label="所属网点" width="100" name="assigned_engineer_outlet_name">
                    <template #default="{data}">
                        {{data.assigned_engineer_outlet_name||'--'}}
                    </template>
                </c-table-column>
                <c-table-column label="操作人" width="150" name="assigned_user_name">
                    <template #default="{data}">
                        {{data.assigned_user_name||'--'}}
                    </template>
                </c-table-column>
            </c-table>

            <c-title v-if="first_filter_logs && first_filter_logs.length>0">【筛选过程】核心圈 + 必备条件</c-title>
            <c-table v-if="first_filter_logs && first_filter_logs.length>0" ref="firstFilterLogs" :data="first_filter_logs" border :paging="false">
<!--                <c-table-column-->
<!--                    label="规则编码"-->
<!--                    width="200"-->
<!--                    name="rule_code"-->
<!--                >-->
<!--                    <template #default="{data}">-->
<!--                        {{data.rule_code}}-->
<!--                    </template>-->
<!--                </c-table-column>-->
                <c-table-column
                    label="规则名称"
                    width="200"
                    name="rule_name"
                >
                    <template #default="{data}">
                        {{data.rule_name}}
                    </template>
                </c-table-column>
                <c-table-column label="筛选前数量" width="80" name="before_count">
                    <template #default="{data}">
                        {{data.before_count||'--'}}
                    </template>
                </c-table-column>
                <c-table-column label="筛选后数量" width="80" name="candidate_count">
                    <template #default="{data}">
                        {{data.candidate_count||'--'}}
                    </template>
                </c-table-column>
                <c-table-column label="筛选结果" width="200" name="filter_result">
                    <template #default="{data, index}">
                        <c-link v-if="data.filter_result && data.filter_result.length > 0" :ref="`filter${data.log_id}`" @click.native.stop="toggleFilterDetail(data)">查看筛选结果</c-link>
                        <span v-else-if="data.filter_result && data.filter_result.length === 0">无结果</span>
                        <span v-else>--</span>
                    </template>
                </c-table-column>
            </c-table>

            <c-title v-if="second_filter_logs && second_filter_logs.length>0">【筛选过程】网点 + 必备条件</c-title>
            <c-table v-if="second_filter_logs && second_filter_logs.length>0" ref="secondFilterLogs" :data="second_filter_logs" border :paging="false">
<!--                <c-table-column-->
<!--                    label="规则编码"-->
<!--                    width="200"-->
<!--                    name="rule_code"-->
<!--                >-->
<!--                    <template #default="{data}">-->
<!--                        {{data.rule_code}}-->
<!--                    </template>-->
<!--                </c-table-column>-->
                <c-table-column
                    label="规则名称"
                    width="200"
                    name="rule_name"
                >
                    <template #default="{data}">
                        {{data.rule_name}}
                    </template>
                </c-table-column>
                <c-table-column label="筛选前数量" width="80" name="before_count">
                    <template #default="{data}">
                        {{data.before_count||'--'}}
                    </template>
                </c-table-column>
                <c-table-column label="筛选后数量" width="80" name="candidate_count">
                    <template #default="{data}">
                        {{data.candidate_count||'--'}}
                    </template>
                </c-table-column>
                <c-table-column label="筛选结果" width="200" name="filter_result">
                    <template #default="{data, index}">
                        <c-link v-if="data.filter_result && data.filter_result.length > 0" :ref="`filter${data.log_id}`" @click.native.stop="toggleFilterDetail(data)">查看筛选结果</c-link>
                        <span v-else-if="data.filter_result && data.filter_result.length === 0">无结果</span>
                        <span v-else>--</span>
                    </template>
                </c-table-column>
            </c-table>

            <c-title v-if="engineer_scores && engineer_scores.length>0">【排序过程】派单值高到低排序</c-title>
            <c-table v-if="engineer_scores && engineer_scores.length>0" ref="engineer_scores" :data="engineer_scores" border :paging="false">
                <c-table-column
                    label="工程师"
                    name="engineer_name"
                    width="200"
                >
                    <template #default="{data}">
                        {{data.engineer_name}}
                    </template>
                </c-table-column>
                <c-table-column label="派单值" name="total_score"  width="80">
                    <template #default="{data}">
                        {{data.total_score.toFixed(2)||'--'}}
                    </template>
                </c-table-column>
                <c-table-column
                    label="是否派单工程师"
                    name="is_selected"
                    width="80"
                >
                    <template #default="{data}">
                        <span v-if="data.is_selected == 1" style="color: green">是</span>
                    </template>
                </c-table-column>
                <c-table-column label="计算过程" name="rule_scores" width="200">
                    <template #default="{data, index}">
                        <c-link v-if="data.rule_scores" :ref="`score${data.engineer_id}`" @click.native.stop="toggleScoreDetail(data)">查看计算过程</c-link>
                        <span v-else>--</span>
                    </template>
                </c-table-column>
            </c-table>
        </div>

		<c-window ref="filterWindow" title="筛选结果" width="500" align="end" @click.native.stop>
			<c-table ref="filterTable" :paging="false" height="240">
                <c-table-column
                    label="工程师"
                    width="100"
                    name="engineerName"
                ></c-table-column>
                <c-table-column
                    label="筛选结果"
                    width="300"
                    name="filterInfo"
                    :ellipsis="false"
                ></c-table-column>
            </c-table>
		</c-window>

		<c-window ref="scoreWindow" title="计算过程" width="600" align="end" @click.native.stop>
			<c-table ref="scoreTable" :paging="false" height="240">
                <c-table-column
                    label="派单规则项"
                    width="300"
                >
                    <template #default="{data, index}">
                        <p style="font-size: 14px;"><b>{{index + 1}}. {{data.rule_name}}</b></p>
                        <p style="margin-left: 1.3em; font-size: 12px; color: #999;">{{data.score_dimension}}</p>
                    </template>
                </c-table-column>
                <c-table-column
                    label="原始值"
                    width="80"
                    name="raw_score"
                >
                    <template #default="{data}">
                        <span style="color: #333;">{{data.raw_score}}</span>
                    </template>
                </c-table-column>
                <c-table-column
                    label="所占权重"
                    width="80"
                >
                    <template #default="{data}">
                        <span style="color: #333;">{{(data.weight * 100).toFixed(0)}}%</span>
                    </template>
                </c-table-column>
                <c-table-column
                    label="派单值"
                    width="80"
                >
                    <template #default="{data}">
                        <span style="color: #00A1E9;">{{data.final_score}}</span>
                    </template>
                </c-table-column>
            </c-table>
            
            <div v-if="scoreDetail" class="score-count flex-end-center">
                <span>综合派单值：({{scoreDetail.rule_scores.map(item => item.final_score).join('+')}}=)</span>
                <strong>{{scoreDetail.total_score.toFixed(2)}}</strong>
            </div>
		</c-window>
    </c-dialog>
</template>

<script>
export default {
    name: 'afterSaleOrderDispatchLog',

    props: {
        id: [String, Number],
        dispatch_id: [String, Number]
    },

    data() {
        return {
            dispatch_result: {},
            first_filter_logs: [],
            second_filter_logs: [],
            manual_dispatch_logs: [],
            engineer_scores: [],
            scoreDetail: null
        }
    },

    mounted() {
        this._windowHide = () => {
            this.$refs.filterWindow.hide();
            this.$refs.scoreWindow.hide();
        }
        window.addEventListener('click', this._windowHide);
    },

    beforeDestroy() {
        window.removeEventListener('click', this._windowHide);
    },

    methods: {
        open() {
            this.request({
                url: '/after/sale/order/dispatch/log',
                data: {
                    order_id:this.id,
                    dispatch_id:this.dispatch_id
                },
                loading: true,
                success: data => {
                    this.dispatch_result =  data.result;
                    this.first_filter_logs = data.first_filter_logs;
                    this.second_filter_logs = data.second_filter_logs;
                    this.manual_dispatch_logs = data.manual_dispatch_logs;
                    this.engineer_scores = data.engineer_scores;
                    this.$refs.dialog.open();
                }
            });
        },

        toggleFilterDetail(data) {
            this.$refs.scoreWindow.hide();
            this.$refs.filterWindow.show(this.$refs[`filter${data.log_id}`], 'left', 'start');
            this.$refs.filterTable.setData(data.filter_result);
        },

        toggleScoreDetail(data) {
            this.$refs.filterWindow.hide();
            this.$refs.scoreWindow.show(this.$refs[`score${data.engineer_id}`], 'left', 'start');
            this.$refs.scoreTable.setData(data.rule_scores);
            this.scoreDetail = data;
        }
    }
}
</script>

<style lang="stylus" scoped>
    .score-count {
        height: 48px;
        border-top: 1px solid var(--unit-border);
        padding: 0 20px;
        font-size: 13px;
        color: #666;

        strong {
            margin-left: 6px;
            font-size: 18px;
            color: #f00;
        }
    }
</style>
